import {
  IonApp, IonIcon,
  IonLabel, IonRouterOutlet, IonTabBar,
  IonTabButton,
  IonTabs,
  // eslint-disable-next-line
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/normalize.css';
/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';
import { homeSharp, searchSharp } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import './App.scss';
import HomePage from './pages/HomePage';
import ProcessGoalsPage from './pages/ProcessGoalsPage';
import Search from './pages/Search';
import TopicPage from './pages/TopicPage';
import DAService from './services/DAService.service';

setupIonicReact();

export default function App() {
  const [screenSize, setScreenSize] = useState<number>(0);

  useEffect(() => {
    // triggers on mount
    setScreenSize(window.innerWidth);

    // triggers only when resize
    window.addEventListener('resize', () => {
      setScreenSize(window.innerWidth);
    });

    window.removeEventListener('resize', () => {

    });
  });

  useEffect(() => {
    DAService.initSearch();
  }, []);

  return (
    <IonApp>
      <IonReactRouter>
        <IonTabs>
          <IonRouterOutlet>
            <Route exact path="/">
              <HomePage screenSize={screenSize} />
            </Route>
            <Route path="/topics/:parent/:child">
              <TopicPage screenSize={screenSize} />
            </Route>
            <Route exact path="/search">
              <Search />
            </Route>
            <Route exact path="/goals/:itemId">
              <ProcessGoalsPage screenSize={screenSize} />
            </Route>
            <Route exact path="/">
              <Redirect to="/" />
              <HomePage screenSize={screenSize} />
            </Route>
          </IonRouterOutlet>
          <IonTabBar slot="bottom" className="tab-bar-container">
            <IonTabButton tab="/" href="/" className="tab-bar-style">
              <IonIcon icon={homeSharp} className="tab-icon-style" />
              <IonLabel className="tab-text-style" data-testid="homepage-tab-title">Home</IonLabel>
            </IonTabButton>
            <IonTabButton tab="/search" href="/search" className="tab-bar-style">
              <IonIcon icon={searchSharp} className="tab-icon-style" />
              <IonLabel className="tab-text-style" data-testid="search-tab-title">Search</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonApp>
  );
}
